import { CUSTOM_MEDIA_VAR_ID_START } from "@constants/media_vars";
import {
  ClientModelVariable,
  CustomClientModelVariable
} from "@services/api/types";

export const getLastMediaVarId = (
  mediaVars: CustomClientModelVariable[] | ClientModelVariable[]
): number => {
  return (
    CUSTOM_MEDIA_VAR_ID_START +
    Math.max(...mediaVars.map((mediaVar) => mediaVar.id))
  );
};
